import React from 'react';
import { ImageBackground } from 'react-native';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import {
  BodyText,
  Stack,
  Touchable,
} from '../../../ui';
import { useMount, useResponsiveEffect } from '../../../../hooks';
import analytics from '../../../../modules/analytics';

import { MEDIUM_SEARCH_TILES_BASE_NAME } from './constants';

const getTestID = (elementName: string) => `${MEDIUM_SEARCH_TILES_BASE_NAME}__${elementName}`;

type ProviderMarketplaceSearchTileProps = {
  testID: string;
  baseTrackingName: string;
  imageSource: string;
  categoryName: string;
  onClick: () => void;
  displayPosition: number;
  hasBadge: boolean;
  badgeText?: string;
};

export default function MediumSearchTile({
  testID,
  baseTrackingName,
  onClick,
  imageSource,
  categoryName,
  displayPosition,
  hasBadge,
  badgeText,
}: ProviderMarketplaceSearchTileProps) {
  const is = useResponsiveEffect();

  useMount(() => {
    analytics.track(`${baseTrackingName}_tile_viewed`, {
      service: categoryName,
      position: displayPosition,
    });
  });

  const handleClick = () => {
    analytics.track(`${baseTrackingName}_tile_clicked`, {
      service: categoryName,
      position: displayPosition,
    });
    onClick();
  };
  return (
    <Touchable onClick={handleClick}>
      <Box
        flex={1}
        flexGrow={1}
        paddingX={4}
        paddingBottom={is.mobileNarrow ? 12 : 16}
        flexBasis={0}
        testID={testID}
        minWidth="calc(100%/3)"
      >
        <Stack
          minHeight="100%"
          borderRadius={4}
          borderWidth={0.5}
          borderStyle="solid"
          alignItems="center"
          borderColor={BrandColor.Silver}
          overflow="hidden"
          testID={`${testID}-search-tile`}
        >
          <ImageBackground
            style={{
              minHeight: 109,
              minWidth: '100%',
              maxWidth: '100%',
              width: 109,
            }}
            source={{ uri: imageSource }}
          >{ hasBadge && (
            <Stack
              space={4}
              paddingX={16}
              paddingTop={80}
              paddingBottom={16}
            >
              <Box
                color={BrandColor.FloraDark}
                paddingX={8}
                paddingY={2}
                borderRadius={4}
                testID={getTestID(`badge-${displayPosition}`)}
              >
                <BodyText
                  color={BrandColor.WhiteWash}
                >
                  {badgeText}
                </BodyText>
              </Box>
            </Stack>
          )}
          </ImageBackground>
          <Box
            flexGrow={1}
            paddingY={8}
            maxWidth={90}
            alignItems="center"
            justifyContent="center"
          >
            <BodyText
              whiteSpace="wrap"
              textAlign="center"
              appearance={is.mobileNarrow ? 'small' : 'normal'}
            >
              {categoryName}
            </BodyText>
          </Box>
        </Stack>
      </Box>
    </Touchable>
  );
}
